module.exports = __webpack_public_path__ + "img/Variable-Flavor-Remix2.cdcd7aae.jpg";